<template>
    <v-card color="" elevation="0" class="px-4">
        <v-divider></v-divider>
        <div class="d-flex pt-3 pb-7 mt-2">
            <v-text-field style="flex: 0 1 300px" v-model="search" append-icon="mdi-magnify" outlined
                :label="this.$t('sales.clientsList.search')" single-line dense hide-details></v-text-field>
            <v-spacer></v-spacer>
            <!-- <v-card outlined class="px-2 py-1"><span class="--total">{{ $n(total.gross, 'currency')
                    }}</span><small>Total
                    bruto</small></v-card>
            <v-card outlined class="px-2 py-1 mx-2"><span class="--total">{{
                $n(total.net, 'currency') }}</span><small>Total líquido</small></v-card>
            <v-card outlined class="px-2 py-1"><span class="--total">{{ $n(documents.length) }}</span><small>{{
                $t('users.total') }}</small></v-card> -->
            <vue-json-to-csv :json-data="[]" :csv-title="`Controle de Pedidos (${computedDateFormatted})`"
                :separator="';'" :labels="csvLabels">
                <v-btn outlined color="primary" height="40" class="ml-2">
                    {{ $t("common.export") }}

                    <v-icon>mdi-download</v-icon>
                </v-btn>
            </vue-json-to-csv>
        </div>
        <v-card outlined>
            <v-data-table :headers="headers" show-expand :items="contentOrders" :loading="loading"
                :single-expand="singleExpand" :expanded.sync="expanded" :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': [10, 25, 50]
                }" :items-per-page="25" :search="search">
                <template v-slot:[`item.createdOn`]="{ item }">
                    <span class="hide-text">{{ item.createdOn }}</span>{{ item.createdOn | dateTimeSampleFromUTC }}
                </template>
                <template v-slot:[`item.pis`]="{ item }">
                    <v-chip small color="primary">{{ $n(item.pis.length) }}</v-chip>
                </template>
                <template v-slot:[`item.range`]="{ item }">
                    {{ item.range.start | date }} - {{ item.range.end | date }}
                </template>
                <template v-slot:[`item.total.commission`]="{ item }">
                    {{ $n(item.total.final * masterStore.piInfo.commRatio, 'currency') }}
                </template>
                <template v-slot:[`item.total.net`]="{ item }">
                    {{ $n(item.total.final - (item.total.final * masterStore.piInfo.commRatio), 'currency') }}
                </template>
                <template v-slot:[`item.total.final`]="{ item }">
                    {{ $n(item.total.final, 'currency') }}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <v-chip label small :color="$t(`whiteLabelStatus.${item.status}[1]`)">{{
                        $t(`whiteLabelStatus.${item.status}[0]`) }}</v-chip>
                </template>

                <template v-slot:[`item.info.url`]="{ item }">
                    <v-tooltip bottom><template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" class="mr-1" color="primary" :loading="item.downloading"
                                @click="downloadFile(item)" icon><v-icon>mdi-download</v-icon>
                            </v-btn>
                        </template>
                        <span>Baixar PI</span>
                    </v-tooltip>
                    <v-tooltip bottom><template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" color="primary" @click="openLink(item)"
                                icon><v-icon>mdi-thumbs-up-down</v-icon></v-btn>
                        </template>
                        <span>Avaliar PI</span>
                    </v-tooltip>
                </template>
                <!-- <template v-slot:[`item.status`]="{ item }">
                    <v-chip label color="orange" class="white--text mx-4" v-if="item.status == 'pending'"
                        small>Pendente</v-chip>
                    <v-chip label color="success" class="white--text mx-4" v-if="item.status == 'approved'"
                        small>Aprovado</v-chip>
                </template> -->



                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-0 --subtable">
                        <v-simple-table>
                            <template v-slot:default>

                                <tbody v-if="item.dataType == 'pi'">
                                    <tr v-for="(subitem, index) in item.pis" :key="index">
                                        <td colspan="2" style="border-left: 2px solid #354f89;">{{ subitem.info.number
                                            }}</td>
                                        <td>
                                            {{ subitem.info.period }}
                                        </td>
                                        <td>
                                            {{ $n(subitem.info.price.gross, 'currency') }}
                                        </td>
                                        <td>
                                            {{ $n(subitem.info.price.agency, 'currency') }}
                                        </td>
                                        <td>
                                            {{ $n(subitem.info.price.net, 'currency') }}
                                        </td>


                                        <td>
                                            {{ subitem.info.createdOn | dateTimeSampleFromUTC }}
                                        </td>
                                        <td>
                                            <v-chip label color="orange" class="white--text mx-4"
                                                v-if="subitem.status == 'pending'" small>Pendente</v-chip>
                                            <v-chip label color="success" class="white--text mx-4"
                                                v-if="subitem.status == 'approved'" small>Aprovado</v-chip>
                                        </td>
                                        <td>
                                            <v-tooltip bottom><template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs" v-on="on" class="mr-1" color="primary"
                                                        :loading="subitem.downloading" @click="downloadFile(subitem)"
                                                        icon><v-icon>mdi-download</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Baixar PI</span>
                                            </v-tooltip>
                                            <v-tooltip bottom><template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs" v-on="on" color="primary"
                                                        @click="openLink(subitem)"
                                                        icon><v-icon>mdi-thumbs-up-down</v-icon></v-btn>
                                                </template>
                                                <span>Avaliar PI</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="item.dataType == 'content'">
                                    <tr v-for="(subitem, index) in item.simulation" :key="index">
                                        <td colspan="2" style="border-left: 2px solid #354f89;">
                                            {{ 
                                                subitem.asu._format
                                            }}
                                        </td>
                                        <td>
                                            Início: {{ getDate(subitem.total.selected[0]) }}
                                            <!-- {{ subitem.info.period }} -->
                                        </td>
                                        <td>
                                            {{ $n(subitem.total.totalSum * subitem.asu.rules.pricing.price , 'currency') }}
                                        </td>
                                        <td>
                                             {{ $n(subitem.total.totalSum * subitem.asu.rules.pricing.price * masterStore.piInfo.commRatio , 'currency') }}
                                            
                                            <!-- {{ $n(subitem.info.price.agency, 'currency') }} -->
                                        </td>
                                        <td>
                                            {{ $n(subitem.total.totalSum * subitem.asu.rules.pricing.price * (1 - masterStore.piInfo.commRatio) , 'currency') }}
                                            <!-- {{ $n(subitem.info.price.net, 'currency') }} -->
                                        </td>


                                        <td>
                                            <!-- {{ subitem.info.createdOn | dateTimeSampleFromUTC }} -->
                                        </td>
                                        <td>
                                            <v-chip label v-if="!item.content" small color="red">Aguardando criativo</v-chip>
                                            <template v-else>
                                                <v-chip label v-if="!item.content" small :color="red">Sem criativo</v-chip>  
                                            </template>
                                            <!-- <v-chip label color="orange" class="white--text mx-4"
                                                v-if="subitem.status == 'pending'" small>Pendente</v-chip>
                                            <v-chip label color="success" class="white--text mx-4"
                                                v-if="subitem.status == 'approved'" small>Aprovado</v-chip> -->
                                        </td>
                                        <td>
                                            <!-- <v-tooltip bottom><template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs" v-on="on" class="mr-1" color="primary"
                                                        :loading="subitem.downloading" @click="downloadFile(subitem)"
                                                        icon><v-icon>mdi-download</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Baixar PI</span>
                                            </v-tooltip>
                                            <v-tooltip bottom><template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs" v-on="on" color="primary"
                                                        @click="openLink(subitem)"
                                                        icon><v-icon>mdi-thumbs-up-down</v-icon></v-btn>
                                                </template>
                                                <span>Avaliar PI</span>
                                            </v-tooltip> -->
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </td>
                </template>

                <!-- <template v-slot:[`item.verified`]="{ item }">
                   
                    <template v-if="item.verified">
                        <v-chip label color="green" class="white--text mx-4" small>{{ $t('sales.clientsList.confirmed')
                        }}</v-chip>
                    </template>
                    <v-chip v-else label color="error lighten-2 " class="mx-4" small>{{ $t('sales.clientsList.noConfirmed')
                    }}</v-chip>
                </template> -->
            </v-data-table>
        </v-card>
        <v-dialog v-model="pi.show" max-width="1024">
            <v-card width="100%" :loading="pi.loading">
                <template v-if="!pi.loading && pi.info">
                    <v-card-title>PI {{ pi.info.number }}</v-card-title>
                    <v-card-text v-if="pi.info && pi.info.price">
                        <v-tabs v-model="tab">
                            <v-tab>Dados do PI</v-tab>
                            <v-tab>Dados do cliente</v-tab>
                            <v-tab>Dados do veículo</v-tab>
                            <v-tab>Arquivo</v-tab>
                        </v-tabs>
                        <div class="pt-3">
                            <v-tabs-items v-model="tab">
                                <v-tab-item>
                                    <v-text-field v-model="pi.info.createdOn" disabled
                                        label="Data de criação"></v-text-field>
                                    <v-text-field v-model="pi.info.period" disabled label="Período"></v-text-field>
                                    <v-text-field v-model="pi.computed.price.gross" disabled
                                        label="Preço bruto"></v-text-field>
                                    <v-text-field v-model="pi.computed.price.agency" disabled
                                        label="Comissão TMT"></v-text-field>
                                    <v-text-field v-model="pi.computed.price.net" disabled
                                        label="Preço líquido"></v-text-field>

                                </v-tab-item>
                                <v-tab-item>
                                    <v-text-field v-model="pi.info.advertiser.company" :disabled="!edit"
                                        label="Nome da empresa"></v-text-field>
                                    <v-text-field v-model="pi.info.advertiser.address" :disabled="!edit"
                                        label="Endereço"></v-text-field>
                                    <v-text-field v-model="pi.info.advertiser.document" :disabled="!edit"
                                        label="CNPJ"></v-text-field>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-text-field v-model="pi.info.publisher.company" :disabled="!edit"
                                        label="Nome da empresa"></v-text-field>
                                    <v-text-field v-model="pi.info.publisher.address" :disabled="!edit"
                                        label="Endereço"></v-text-field>
                                    <v-text-field v-model="pi.info.publisher.document" :disabled="!edit"
                                        label="CNPJ"></v-text-field>
                                    <v-text-field v-model="pi.info.publisher.name" :disabled="!edit"
                                        label="Nome"></v-text-field>
                                    <v-text-field v-model="pi.info.publisher.email" :disabled="!edit"
                                        label="E-mail"></v-text-field>
                                </v-tab-item>
                                <v-tab-item>
                                    <iframe :src="pi.secure" width="100%" height="516"></iframe>
                                </v-tab-item>
                            </v-tabs-items>
                        </div>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn @click="pi.show = false" text>Cancelar</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn v-if="!isEditing" :disabled="pi.status == 'approved'" elevation="0" class="mx-1"
                                @click="reprove()" color="error">Reprovar</v-btn>
                            <v-btn v-if="!isEditing" :disabled="pi.status == 'approved'" elevation="0"
                                @click="approve()" :loading="approving" color="success">Aprovar</v-btn>
                            <v-btn v-if="isEditing" elevation="0" @click="save()" color="success">Salvar e
                                reprocessar</v-btn>
                        </v-card-actions>


                    </v-card-text>
                </template>
                <template v-else>
                    <v-skeleton-loader class="mx-auto" max-width="100%" type="card"></v-skeleton-loader>
                </template>
            </v-card>
        </v-dialog>
        <v-dialog v-model="form.show" max-width="720">
            <v-card width="100%">
                <v-card-title>Reprovar PI</v-card-title>
                <v-card-text>
                    <v-radio-group v-model="form.action">
                        <v-radio value="edit" label="Editar informações do PI"></v-radio>
                        <v-radio value="placement" label="Alterar cronograma de veiculação" disabled></v-radio>
                        <v-radio value="cancel" label="Cancelar PI" disabled></v-radio>
                    </v-radio-group>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="!form.action" @click="advance()" color="success" elevation="0">Continuar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="piApprovedSuccess" type="success">PI aprovado com sucesso! <template
                v-slot:action="{ attrs }">
                <v-btn icon v-bind="attrs" @click="piApprovedSuccess = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>
<script>
import moment from 'moment'
import config from '@/store/config'
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import VueJsonToCsv from "vue-json-to-csv";
import { mapActions, mapState } from "vuex";

import { initializeApp } from "firebase/app";
import axios from "axios"
import { getFirestore, collection, query, where, doc, updateDoc, getDocs } from "firebase/firestore";
export default {
    name: 'OpecOrders',
    components: {
        VueJsonToCsv
    },
    data() {
        return {
            statusGroup: {
                content: [
                    'waiting_content',
                    'awaiting_content_approval',
                    'waiting_content_approval',
                    'content_reproved',
                    'content_approved',
                ],
                pi: [
                    'waiting_pi_approval',
                ]
            },
            expanded: [],
            singleExpand: false,
            contentOrders: [],
            piApprovedSuccess: false,
            approving: false,
            form: {
                action: '',
                show: false,
            },
            isEditing: false,
            edit: false,
            tab: 0,
            pi: {
                show: false,
                loading: false,
                secure: '',
                info: {
                    name: ""
                }
            },
            loading: true,
            search: this.$route.query.q ? this.$route.query.q : "",
            documents: [],
            docToExport: []
        }
    },

    computed: {
        ...mapState("groupStores", [
            "allStores",
            "masterStore",
            "subStores",
            "selectedStore",
        ]),
        total() {
            const res = {
                gross: 0,
                net: 0,
                agency: 0
            }
            this.documents.forEach((item) => {
                if (item.info && item.info.price) {
                    res.gross += item.info.price.gross
                    res.net += item.info.price.net
                    res.agency += item.info.price.agency
                }
            })
            return res
        },
        csvLabels() {
            return {
                name: { title: 'Nombre' },
                company: { title: 'Empresa' },
                document: { title: 'RUC' },
                score: { title: 'Score' },
                email: { title: "Correo Electrónico" },
                phone: { title: "Teléfono" },
                createdOn: { title: "Creado en" },
                confirmedOn: { title: "Verificado en" }

            }
        },
        computedDateFormatted() {
            return moment().format("YYYY-MM-DD HH mm");
        },
        headers() {
            return [
                // {
                //     text: "Pedido de Inserção",
                //     align: 'start',
                //     sortable: true,
                //     value: 'info.number',
                // },
                // {
                //     text: "ID de transação",
                //     align: 'start',
                //     sortable: true,
                //     value: 'order',
                // },
                // {
                //     text: "Período",
                //     align: 'start',
                //     sortable: true,
                //     value: 'info.period',
                // },
                // {
                //     text: "Veículo",
                //     align: 'start',
                //     sortable: true,
                //     value: 'info.publisher.company',
                // },

                // {
                //     text: "CNPJ Veículo",
                //     align: 'start',
                //     sortable: true,
                //     value: 'info.publisher.document',
                // },

                // {
                //     text: "Cliente",
                //     align: 'start',
                //     sortable: true,
                //     value: 'info.advertiser.company',
                // },
                // {
                //     text: "CNPJ Cliente",
                //     align: 'start',
                //     sortable: true,
                //     value: 'info.advertiser.document',
                // },

                // {
                //     text: "Preço bruto",
                //     align: 'start',
                //     sortable: true,
                //     value: 'info.price.gross',
                // },

                // {
                //     text: "Comissão TMT",
                //     align: 'start',
                //     sortable: true,
                //     value: 'info.price.agency',
                // },

                // {
                //     text: "Preço líquido",
                //     align: 'start',
                //     sortable: true,
                //     value: 'info.price.net',
                // },


                // {
                //     text: "",
                //     align: 'end',
                //     sortable: false,
                //     value: 'info.url'
                // }
                {
                    text: "Pedido de Inserção",
                    align: 'start',
                    sortable: true,
                    value: 'pis',
                },
                {
                    text: "ID de transação",
                    align: 'start',
                    sortable: true,
                    value: 'id',
                },
                {
                    text: "Período",
                    align: 'start',
                    sortable: true,
                    value: 'range',
                },

                {
                    text: "Preço bruto",
                    align: 'start',
                    sortable: true,
                    value: 'total.final',
                },

                {
                    text: "Comissão TMT",
                    align: 'start',
                    sortable: true,
                    value: 'total.commission',
                },

                {
                    text: "Preço líquido",
                    align: 'start',
                    sortable: true,
                    value: 'total.net',
                },

                {
                    text: "Criado em",
                    align: 'start',
                    sortable: true,
                    value: 'createdOn',
                },
                {
                    text: "Status",
                    align: 'start',
                    sortable: false,
                    value: 'status'
                },
                { text: '', value: 'data-table-expand' },
                //  {
                //     text: "",
                //     align: 'end',
                //     sortable: false,
                //     value: 'info.url'
                // }


            ]
        },
        // actives(){
        //     let docs = JSON.parse(JSON.stringify(this.documents))
        //     const i = 0;
        //     const result = docs.reduce(
        //     (accumulator, currentValue) => { return currentValue.hasOwnProperty('verified') && currentValue.verified ? accumulator+1 : accumulator}, i);
        //     return  result  
        // }
    },
    mounted() {
        this.loadDocuments()
    },
    watch: {
        '$route.params.tab'(value) {
            if (value != 1)
                this.search = this.$route.query.q ? this.$route.query.q : ''
        },
        'search': {
            handler(value) {
                if (value) {
                    if (this.$route.query.q != value) {
                        this.$router.replace(`/sales/opec?q=${value}`)
                    }
                }
                else {
                    this.$router.replace(`/sales/opec`)
                }
            }
        }
    },
    methods: {
        ...mapActions("groupStores", [
            "getAllStores",
            "getMasterStore",
            "getSubStores",
            "getSelectedStore",
        ]),
        getDate(date){
            return moment(`${date.year}-${date.month}-${date.monthDay}`).format('DD/MM/YYYY')
        },
        loadOrders() {
            const firebase = initializeApp(config);
            const db = getFirestore(firebase);
            const q = query(collection(db, "orders"));
            const querySnapshot = getDocs(q);
            querySnapshot.then((docs) => {
                if (!docs.empty) {
                    docs.forEach((doc) => {
                        const data = doc.data()
                        // insert to content status
                    
                        if (this.statusGroup.pi.includes(data.status)) {
                            const pis = this.documents.filter(pi => pi.order == data.id)
                            data.pis = pis
                            data.dataType = 'pi'
                            this.contentOrders.push(data)
                        }
                        if (this.statusGroup.content.includes(data.status)) {
                            const pis = this.documents.filter(pi => pi.order == data.id)
                            data.pis = pis
                            data.dataType = 'content'
                            this.contentOrders.push(data)
                        }
                    })
                }
                this.loading = false
            })
        },
        // saveScore(item){
        //     console.log('item', item)
        //     item.score = item.newScore
        //     item.openScore = false
        //     const firebase = initializeApp(config);
        //     const db = getFirestore(firebase);

        //     const masterRef = doc(db, "accounts", item.id);
        //     console.log('item to save', item);
        //     updateDoc(masterRef, {
        //         "score": item.score
        //     });

        //     this.loadDocuments()
        // },
        advance() {
            this.form.show = false
            if (this.form.action == 'edit') {
                this.edit = true
                this.isEditing = true
                this.tab = 1
            }
        },
        loadDocuments() {
            this.loading = true
            this.contentOrders = []
            const firebase = initializeApp(config)
            const db = getFirestore(firebase);
            const q = query(collection(db, "pis"));
            const querySnapshot = getDocs(q);
            const documents = []
            querySnapshot.then((docs) => {
                docs.forEach((doc) => {
                    // const computed = {
                    //     createdOn: moment(doc.data().createdOn).format('DD/MM/YYYY HH:mm:ss'),
                    // }
                    const dt = doc.data()
                    // dt.document = '<span style="display: none">' + doc.data().document.replace(' ', '').replace('-', '') + '  |</span>' + dt.document 
                    documents.push({
                        ...dt, downloading: false, id: doc.id, computed: {
                            price: {
                                gross: this.$n(dt.info.price.gross, 'currency'),
                                net: this.$n(dt.info.price.net, 'currency'),
                                agency: this.$n(dt.info.price.agency, 'currency'),
                            }
                        }
                    })
                    const doctoExport = {
                        name: doc.data().name,
                        company: doc.data().company,
                        email: doc.data().email,
                        document: doc.data().document,
                        phone: doc.data().phoneNumber,
                        score: doc.data().score ? doc.data().score : 'Pendente',

                        createdOn: moment(doc.data().createdOn).format('YYYY-MM-DD HH:mm:ss'),
                        confirmedOn: doc.data().verified ? moment(doc.data().verified).format('YYYY-MM-DD HH:mm:ss') : '',
                    }
                    this.docToExport.push(doctoExport)
                })
                this.documents = documents
                this.loadOrders()
            })
        },
        reprove() {
            this.form.show = true
        },
        approve() {
            console.log('#A1')
            this.approving = true
            const current = this.pi.order
            this.pi.status = 'approved'
            const firebase = initializeApp(config);
            const db = getFirestore(firebase);

            const pisRef = doc(db, "pis", this.pi.id);

            updateDoc(pisRef, {
                "status": 'approved'
            });
            console.log('#A2')


            const allOfOrder = this.documents.filter(doc => doc.order == current)
            let allAproved = true
            let pis = []
            allOfOrder.forEach((doc) => {
                if (!doc.hasOwnProperty('status') || doc.status != 'approved') {
                    allAproved = false
                    console.log('#A3.1')
                }
                else {
                    pis.push(doc.info.name)
                    console.log('#A3.2')
                }
            })
            console.log('#A4')
            if (allAproved) {
                const orderRef = doc(db, "orders", this.pi.order);
                console.log('#A4.1')
                updateDoc(orderRef, {
                    "pi": pis,
                    "status": 'waiting_placement'
                }).then(() => {
                    console.log('#A4.1.1')
                    this.pi.show = false
                    this.form.show = false
                    this.approving = false
                })
            }
            else {
                console.log('#A5')
                this.approving = false
                this.form.show = false
                this.pi.show = false
            }
            this.piApprovedSuccess = true
            this.loadDocuments()
        },
        openLink(e) {
            this.pi.loading = true
            this.pi.show = true
            const prefix = this.$sandbox ? 'http://canaldoanuncio.test/api/v1/' : 'https://app.canaldoanuncio.com/api/v1/'
            if (e) {
                e.ready = false
                axios.get(`${prefix}security/open/link?region=sa-east-1&url=${e.url}&src=${e.url}`).then((res) => {
                    this.pi = {
                        ...e,
                        secure: res.data.data,
                        show: true,
                        loading: false
                    }
                    // this.pi.secure = res.data.data
                    // this.download_file(res.data.data, `${e.info.number}.pdf`)
                })
            }
        },

        downloadFile(e) {
            e.downloading = true
            const prefix = this.$sandbox ? 'http://canaldoanuncio.test/api/v1/' : 'https://app.canaldoanuncio.com/api/v1/'
            if (e) {
                e.ready = false
                axios.get(`${prefix}security/open/link?region=sa-east-1&url=${e.url}&src=${e.url}`).then((res) => {
                    this.download_file(res.data.data, `PI ${e.info.number}.pdf`)
                    e.downloading = false
                    // this.pi.secure = res.data.data
                    // this.download_file(res.data.data, `${e.info.number}.pdf`)
                })
            }
        },


        download_file(fileURL, fileName) {
            // for non-IE
            if (!window.ActiveXObject) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                var filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
                save.download = fileName || filename;
                if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                    document.location = save.href;
                    // window event not working here
                } else {
                    var evt = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    save.dispatchEvent(evt);
                    (window.URL || window.webkitURL).revokeObjectURL(save.href);
                }
            }

            // for IE < 11
            else if (!!window.ActiveXObject && document.execCommand) {
                var _window = window.open(fileURL, '_blank');
                _window.document.close();
                _window.document.execCommand('SaveAs', true, fileName || fileURL)
                _window.close();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.hide-text {
    font-size: 0;
    text-indent: -999em;
}

.--total {
    line-height: .75em;
    text-align: center;
    display: block;
    font-weight: bold;
    padding-top: 2px;

    &+small {
        line-height: .75em;
        font-size: 70%;
        padding: 5px 0 0 0;
        display: block;
        text-align: center;
    }
}
.--subtable{    
    background: #fafafa;
    box-shadow: none;
    table{
        td, th{
            background: #fafafa;
        }
}
}
</style>